import React from "react";

import {
  Box,
  Button,
  Flex,
  Text,
  Skeleton,
  useColorModeValue,
} from "@chakra-ui/react";

import {
  Ellipsis,
  Eye,
  Trash2,
  ShieldAlert,
} from "lucide-react";

import ThreeDotMenu from "components/Menus/ThreeDotMenu";

import StatusBadge, {
  getCategoryVariant,
} from "components/Badges/StatusBadge";


const StarterKitComponentCard = ({
  component_name,
  component_code,
  description,
  component_images,
  unit_price,
  quantity_in_stock,
  minimum_stock_level,
  is_mandatory,
  active,
  created_at,
  onEdit,
  onDelete,
  loading,
}) => {

//   const cardBg = useColorModeValue(
//     "gray.100",
//     "gray.700"
//   );
const cardBg = useColorModeValue(
  "white",
  "white"
);

  const textColor = useColorModeValue(
    "gray.500",
    "white"
  );

  const BASE_URL =
    process.env.REACT_APP_API_BASE_URL;


  const imageUrl =
    component_images &&
    component_images.length > 0
      ? `${BASE_URL.replace(/\/$/, "")}/${String(
          component_images[0]
        ).replace(/^\/+/, "")}`
      : null;


  const menuItems = [
    {
      icon: <Eye size={16} />,
      text: "View Component",
      onClick: onEdit,
    },
    {
      icon: <Trash2 size={16} />,
      text: "Delete Component",
      onClick: onDelete,
      extraIcon: (
        <ShieldAlert
          size={16}
          color="pink"
        />
      ),
    },
  ];


  return (
    <Box
      borderWidth="1px"
      borderRadius="lg"
      overflow="hidden"
      p="6"
      boxShadow="md"
      maxW="sm"
      bg={cardBg}
    >

      {/* Header */}
      <Flex
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >

        {loading ? (
          <Skeleton
            height="20px"
            width="80px"
          />
        ) : (
          <StatusBadge
            label={
              active
                ? "Active"
                : "Inactive"
            }
            variant={
              active
                ? "success"
                : "danger"
            }
          />
        )}


        {loading ? (
          <Skeleton
            height="20px"
            width="20px"
            borderRadius="50%"
          />
        ) : (
          <ThreeDotMenu
            icon={
              <Ellipsis
                size={20}
                color="grey"
              />
            }
            items={menuItems}
          />
        )}

      </Flex>


      {/* Component Image */}
      <Flex
        justifyContent="center"
        mb={4}
      >

        {loading ? (
          <Skeleton
            height="150px"
            width="100%"
          />
        ) : imageUrl ? (
          <img
            src={imageUrl}
            alt={component_name}
            style={{
              borderRadius: "8px",
              width: "100%",
              maxHeight: "150px",
              objectFit: "contain",
            }}
          />
        ) : (
          <Skeleton
            height="150px"
            width="100%"
          />
        )}

      </Flex>


      {/* Component Name */}
      {loading ? (
        <Skeleton
          height="20px"
          width="200px"
        />
      ) : (
        <Text
          fontWeight="bold"
          fontSize="lg"
          mb={2}
          textAlign="start"
          noOfLines={1}
        >
          {component_name}
        </Text>
      )}


      {/* Component Code */}
      {loading ? (
        <Skeleton
          height="15px"
          width="130px"
        />
      ) : (
        <Text
          fontSize="xs"
          color={textColor}
        >
          {component_code}
        </Text>
      )}


      {/* Description
      {loading ? (
        <Skeleton
          height="15px"
          width="100%"
          mt={3}
        />
      ) : (
        <Text
          fontSize="sm"
          color={textColor}
          mt={3}
          noOfLines={2}
        >
          {description || "No description"}
        </Text>
      )} */}


      {/* Price / Stock */}
      <Flex
        mt={4}
        justifyContent="space-between"
        alignItems="center"
      >

        <Flex alignItems="center">

          {loading ? (
            <>
              <Skeleton
                height="15px"
                width="50px"
                mr={2}
              />

              <Skeleton
                height="15px"
                width="60px"
              />
            </>
          ) : (
            <>
              <Text
                fontSize="xs"
                fontWeight="bold"
                color={textColor}
                mr={2}
              >
                Price
              </Text>

              <Text
                fontSize="xs"
                color={textColor}
              >
                P{unit_price}
              </Text>
            </>
          )}

        </Flex>


        {loading ? (
          <Skeleton
            height="20px"
            width="100px"
          />
        ) : (
          <Button
            onClick={onEdit}
            color="#071D54"
            bg="gray.100"
            variant="link"
            fontSize="xs"
          >
            View Component {">"}
          </Button>
        )}

      </Flex>


      {/* Stock Information */}
      <Flex
        mt={3}
        justifyContent="space-between"
      >

        <Text
          fontSize="xs"
          color={textColor}
        >
          Stock:{" "}
          <strong>
            {quantity_in_stock}
          </strong>
        </Text>

        <Text
          fontSize="xs"
          color={textColor}
        >
          Minimum:{" "}
          <strong>
            {minimum_stock_level}
          </strong>
        </Text>

      </Flex>


      {/* Mandatory + Created */}
      <Flex
        mt={3}
        justifyContent="space-between"
        alignItems="center"
      >

        {loading ? (
          <Skeleton
            height="15px"
            width="80px"
          />
        ) : (
          <Text
            fontSize="xs"
            color={textColor}
          >
            {is_mandatory
              ? "Mandatory"
              : "Optional"}
          </Text>
        )}


        {loading ? (
          <Skeleton
            height="15px"
            width="80px"
          />
        ) : (
          <Text
            fontSize="xs"
            color={textColor}
          >
            {created_at
              ? new Date(
                  created_at
                ).toLocaleDateString()
              : "N/A"}
          </Text>
        )}

      </Flex>

    </Box>
  );
};


export default StarterKitComponentCard;